import { render, staticRenderFns } from "./filePreview.vue?vue&type=template&id=5de0f2cc&scoped=true"
import script from "./filePreview.vue?vue&type=script&lang=js"
export * from "./filePreview.vue?vue&type=script&lang=js"
import style0 from "./filePreview.vue?vue&type=style&index=0&id=5de0f2cc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de0f2cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5de0f2cc')) {
      api.createRecord('5de0f2cc', component.options)
    } else {
      api.reload('5de0f2cc', component.options)
    }
    module.hot.accept("./filePreview.vue?vue&type=template&id=5de0f2cc&scoped=true", function () {
      api.rerender('5de0f2cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/filePreview.vue"
export default component.exports